import { mode } from "@chakra-ui/theme-tools";
export const inputStyles = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "8px",
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("#FFFFFF", "navy.700")(props),
            border: "1px solid",
            color: mode("secondaryGray.900", "white")(props),
            borderColor: mode("#E2E8F0", "navy.600")(props),
            borderRadius: "16px",
            fontSize: "sm",
            p: "20px",
            _placeholder: { color: "#718096" },
          },
        }),
        auth: (props) => ({
          field: {
            fontWeight: "500",
            color: mode("secondaryGray.900", "white")(props),
            bg: mode("#FFFFFF", "navy.700")(props),
            border: "1px solid",
            borderColor: mode("#E2E8F0", "navy.600")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096", fontWeight: "400" },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",
            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            bg: mode("#FFFFFF", "navy.700")(props),
            _placeholder: { color: "#718096" },
          },
        }),
      },
    },
    NumberInput: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",

            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",

            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",

            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: "#718096" },
          },
        }),
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("#FFFFFF", "navy.800")(props),
            border: "1px solid",
            color: mode("secondaryGray.900", "secondaryGray.600")(props),
            borderColor: mode("#E2E8F0", "whiteAlpha.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
          icon: {
            color: mode("secondaryGray.900", "secondaryGray.600")(props),
          },
        }),
        mini: (props) => ({
          field: {
            bg: mode("#FFFFFF", "navy.800")(props),
            border: "0px solid transparent",
            fontSize: "0px",
            p: "10px",
            _placeholder: { color: "#718096" },
          },
          icon: {
            color: "#718096",
          },
        }),
        subtle: (props) => ({
          box: {
            width: "unset",
          },
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",
            color: "secondaryGray.900",
            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            width: "max-content",
            _placeholder: { color: "#4A5568" },
          },
          icon: {
            color: "#718096",
          },
        }),
        transparent: (props) => ({
          field: {
            bg: "transparent",
            border: "0px solid",
            width: "min-content",
            color: mode("secondaryGray.900", "secondaryGray.600")(props),
            borderColor: "transparent",
            padding: "0px",
            paddingLeft: "8px",
            paddingRight: "20px",
            fontWeight: "700",
            fontSize: "14px",
            _placeholder: { color: "#718096" },
          },
          icon: {
            transform: "none !important",
            position: "unset !important",
            width: "unset",
            color: "#718096",
            right: "0px",
          },
        }),
        auth: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",

            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: mode("#FFFFFF", "transparent")(props),
            border: "1px solid",

            borderColor: mode("#E2E8F0", "secondaryGray.100")(props),
            borderRadius: "16px",
            _placeholder: { color: "#718096" },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: "#718096" },
          },
        }),
      },
    },
    // PinInputField: {
    //   variants: {
    //     main: (props) => ({
    //       field: {
    //         bg: "red !important",
    //         border: "1px solid",
    //         color: mode("secondaryGray.900", "white")(props),
    //         borderColor: mode("secondaryGray.100", "whiteAlpha.100")(props),
    //         borderRadius: "16px",
    //         _placeholder: { color: "secondaryGray.600" },
    //       },
    //     }),
    //   },
    // },
  },
};
